<template>
  <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex">
    <a
      :href="card.url"
      @click.prevent="openConfiguratorUrl(card.url)"
      class="tw-relative card model-car model-card bic-card mb-4 h-auto w-100 cursor-pointer"
    >
      <div class="tw-absolute tw-top-2 tw-left-2 tw-right-2 tw-flex tw-items-center tw-gap-1.5 bic-card__badge-row">
        <span class="bic-card__featured-badge">Kiemelt ajánlat</span>
        <span class="badge badge-danger badge-sm text-uppercase" v-if="card.stockNumber > 0">Készleten</span>
        <month-badge v-else :date="card.takeOverMonth" />
        <fuel-type-badge :fuel-type="card.fuelType" />
      </div>

      <car-image-rotator
        v-if="card.angles && card.angles.length"
        :angles="card.angles"
        :fallback="carImage"
        :alt="card.alt"
        :zoom="1.25"
      />
      <img
        v-else
        :src="carImage"
        class="card-img-top"
        :alt="card.alt"
      >

      <div class="card-body d-flex flex-column">
        <h5 class="bic-card__name mb-2">
          {{ card.name }}
        </h5>

        <div class="row no-gutters justify-content-center bic-card__icons mb-3" v-if="card.icons && card.icons.length">
          <div class="col-4 text-center" v-for="(icon, i) in card.icons" :key="i">
            <div class="addition-icon" :class="`addition-icon--${icon.class}`"></div>
            <span class="blue d-block text-center bic-card__icon-label">{{ icon.label }}</span>
          </div>
        </div>

        <div class="bic-card__meta mb-2">
          <p class="card-text mb-1" v-if="card.months">
            <strong>Futamidő:</strong> {{ card.months }} hónap
          </p>
          <p class="card-text mb-1" v-if="card.mileage">
            <strong>Éves km:</strong> {{ (card.mileage * 1000) | currency }} km
          </p>
        </div>

        <button
          type="button"
          class="btn btn-block btn-primary btn-sm mt-auto"
        >
          <template v-if="card.price">
            {{ card.price | currency }} Ft + ÁFA
          </template>
          <template v-else>
            Hívjon bennünket!
          </template>
        </button>
      </div>
    </a>
  </div>
</template>

<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class BicCard extends Vue {

  @Prop(Object) card;

  get carImage() {
    return this.card.image || 'https://irp-cdn.multiscreensite.com/a769bb7b/dms3rep/multi/tablet/Car-Servicing-pg-img1-960x600.jpg';
  }

  openConfiguratorUrl(url) {
    if (url && url.trim() !== '') {
      location.href = url;
    }
  }
}
</script>

<style scoped>
.model-card:hover {
  text-decoration: none;
}

.card-text {
  color: #676868;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
